export default __webpack_public_path__ + "static/media/9e629de6-027e-431c-b3d3-bc2762b8238c.c3ea17ec.webp";